export const TRAINING_PROGRESS_COPY = {
    uk: {
        admin: {
            loading: 'Завантаження даних про прогрес тренування...',
            loadError: 'Не вдалося завантажити дані прогресу тренування',
            header: {
                detail: 'Прогрес тренування — {name}',
                back: '← Повернутися до всіх студентів',
            },
            summary: {
                totalStudents: {
                    heading: 'Усього студентів',
                    description: '{count} студентів',
                },
                preTrip: {
                    heading: 'Передрейсовий огляд завершено',
                    description: '{percent}%',
                },
                skills: {
                    heading: 'Навички виконано',
                    description: '{percent}%',
                },
                certified: {
                    heading: 'Повністю сертифіковані',
                    description: '{percent}%',
                },
            },
            table: {
                columns: {
                    student: 'Студент',
                    progress: 'Прогрес',
                    preTrip: 'Передрейсовий огляд',
                    skills: 'Навички',
                    road: 'Дорожній тест',
                    actions: 'Дії',
                },
                status: {
                    completed: 'Завершено',
                    inProgress: 'У процесі',
                },
                viewDetails: 'Переглянути деталі',
                empty: 'Дані про прогрес студентів ще відсутні.',
            },
        },
        training: {
            loading: 'Завантаження прогресу тренування...',
            loadError: 'Не вдалося завантажити прогрес тренування',
            updateError: 'Не вдалося оновити прогрес',
            notFound: 'Прогрес тренування не знайдено.',
            overall: {
                heading: 'Загальний прогрес',
                percent: '{percent}% виконано',
            },
            sections: {
                preTrip: {
                    heading: 'Передрейсовий огляд ({percent}% виконано)',
                },
                skills: {
                    heading: 'Навички ({percent}% виконано)',
                },
                road: {
                    heading: 'Дорожній тест ({percent}% виконано)',
                },
            },
            fields: {
                preTrip: {
                    preTripInsideCab: 'Кабіна',
                    preTripBrakes: 'Гальма',
                    preTripCoupling: 'Зчеплення',
                    preTripTractorFront: 'Тягач (перед)',
                    preTripTractorSide: 'Тягач (бік)',
                    preTripTrailer: 'Причіп',
                },
                skills: {
                    skill1: 'Навичка 1',
                    skill2: 'Навичка 2',
                    skill3: 'Навичка 3',
                    skill4: 'Навичка 4',
                },
                road: {
                    roadTest: 'Дорожній тест',
                },
            },
            statuses: {
                NOT_STARTED: 'Не розпочато',
                IN_PROGRESS: 'У процесі',
                PASSED: 'Завершено',
                FAILED: 'Не пройдено',
                NEEDS_REVIEW: 'Потребує перегляду',
                DONE: 'Завершено',
            },
        },
        studentHeader: 'Прогрес тренування',
    },
    ru: {
        admin: {
            loading: 'Загрузка данных о прогрессе тренировки...',
            loadError: 'Не удалось загрузить данные о прогрессе тренировки',
            header: {
                detail: 'Прогресс тренировки — {name}',
                back: '← Назад ко всем студентам',
            },
            summary: {
                totalStudents: {
                    heading: 'Всего студентов',
                    description: '{count} студентов',
                },
                preTrip: {
                    heading: 'Предрейсовая проверка завершена',
                    description: '{percent}%',
                },
                skills: {
                    heading: 'Навыки выполнены',
                    description: '{percent}%',
                },
                certified: {
                    heading: 'Полностью сертифицированы',
                    description: '{percent}%',
                },
            },
            table: {
                columns: {
                    student: 'Студент',
                    progress: 'Прогресс',
                    preTrip: 'Предрейсовая проверка',
                    skills: 'Навыки',
                    road: 'Дорожный тест',
                    actions: 'Действия',
                },
                status: {
                    completed: 'Завершено',
                    inProgress: 'В процессе',
                },
                viewDetails: 'Посмотреть детали',
                empty: 'Данные о прогрессе студентов пока отсутствуют.',
            },
        },
        training: {
            loading: 'Загрузка прогресса тренировки...',
            loadError: 'Не удалось загрузить прогресс тренировки',
            updateError: 'Не удалось обновить прогресс',
            notFound: 'Прогресс тренировки не найден.',
            overall: {
                heading: 'Общий прогресс',
                percent: '{percent}% завершено',
            },
            sections: {
                preTrip: {
                    heading: 'Предрейсовая проверка ({percent}% завершено)',
                },
                skills: {
                    heading: 'Навыки ({percent}% завершено)',
                },
                road: {
                    heading: 'Дорожный тест ({percent}% завершено)',
                },
            },
            fields: {
                preTrip: {
                    preTripInsideCab: 'Кабина',
                    preTripBrakes: 'Тормоза',
                    preTripCoupling: 'Сцепка',
                    preTripTractorFront: 'Тягач — перед',
                    preTripTractorSide: 'Тягач — бок',
                    preTripTrailer: 'Прицеп',
                },
                skills: {
                    skill1: 'Навык 1',
                    skill2: 'Навык 2',
                    skill3: 'Навык 3',
                    skill4: 'Навык 4',
                },
                road: {
                    roadTest: 'Дорожный тест',
                },
            },
            statuses: {
                NOT_STARTED: 'Не начато',
                IN_PROGRESS: 'В процессе',
                PASSED: 'Завершено',
                FAILED: 'Не пройдено',
                NEEDS_REVIEW: 'Требует проверки',
                DONE: 'Завершено',
            },
        },
        studentHeader: 'Прогресс тренировки',
    },
    es: {
        admin: {
            loading: 'Cargando datos de progreso de entrenamiento...',
            loadError: 'No se pudo cargar los datos de progreso del entrenamiento',
            header: {
                detail: 'Progreso de entrenamiento — {name}',
                back: '← Volver a todos los estudiantes',
            },
            summary: {
                totalStudents: {
                    heading: 'Total de estudiantes',
                    description: '{count} estudiantes',
                },
                preTrip: {
                    heading: 'Inspección previa completada',
                    description: '{percent}%',
                },
                skills: {
                    heading: 'Habilidades completadas',
                    description: '{percent}%',
                },
                certified: {
                    heading: 'Totalmente certificados',
                    description: '{percent}%',
                },
            },
            table: {
                columns: {
                    student: 'Estudiante',
                    progress: 'Progreso',
                    preTrip: 'Inspección previa',
                    skills: 'Habilidades',
                    road: 'Prueba en carretera',
                    actions: 'Acciones',
                },
                status: {
                    completed: 'Completado',
                    inProgress: 'En progreso',
                },
                viewDetails: 'Ver detalles',
                empty: 'Aún no hay progreso de estudiantes.',
            },
        },
        training: {
            loading: 'Cargando progreso de entrenamiento...',
            loadError: 'No se pudo cargar el progreso de entrenamiento',
            updateError: 'No se pudo actualizar el progreso',
            notFound: 'No se encontró progreso de entrenamiento.',
            overall: {
                heading: 'Progreso general',
                percent: '{percent}% completado',
            },
            sections: {
                preTrip: {
                    heading: 'Inspección previa ({percent}% completado)',
                },
                skills: {
                    heading: 'Habilidades ({percent}% completado)',
                },
                road: {
                    heading: 'Prueba en carretera ({percent}% completado)',
                },
            },
            fields: {
                preTrip: {
                    preTripInsideCab: 'Cabina',
                    preTripBrakes: 'Frenos',
                    preTripCoupling: 'Acople',
                    preTripTractorFront: 'Tractor - frontal',
                    preTripTractorSide: 'Tractor - lateral',
                    preTripTrailer: 'Remolque',
                },
                skills: {
                    skill1: 'Habilidad 1',
                    skill2: 'Habilidad 2',
                    skill3: 'Habilidad 3',
                    skill4: 'Habilidad 4',
                },
                road: {
                    roadTest: 'Prueba en carretera',
                },
            },
            statuses: {
                NOT_STARTED: 'Sin iniciar',
                IN_PROGRESS: 'En progreso',
                PASSED: 'Completado',
                FAILED: 'Fallido',
                NEEDS_REVIEW: 'Necesita revisión',
                DONE: 'Completado',
            },
        },
        studentHeader: 'Progreso de entrenamiento',
    },
};

export const DEFAULT_SCHEDULE_COPY = {
    header: {
        title: 'Schedule Training',
    },
    tabs: {
        skill: 'Skills',
        road: 'Road',
    },
    weekNav: {
        previous: '← Previous Week',
        next: 'Next Week →',
    },
    messages: {
        noTrucks: 'No active training trucks are available. Please contact an instructor.',
        noTrucksForType: 'No {type} trucks are currently available. Please choose a different training type or check back later.',
        booked: 'Training session booked for {time}. Status: {status}',
        cancelSuccess: 'Session cancelled successfully.',
    },
    booking: {
        heading: {
            skill: 'Book Skills Training',
            road: 'Book Road Training',
        },
        selectedTime: 'Selected time: {time}',
        confirm: 'Confirm Booking',
        booking: 'Booking...',
        truckSelectLabel: 'Select truck',
        truckSelectPlaceholder: 'Choose a truck',
    },
    table: {
        time: 'Time',
        closed: 'Closed',
        yourSession: 'Your session',
        reserved: 'Reserved slot',
        buttons: {
            selected: 'Selected',
            book: 'Book',
            approved: 'Approved',
            available: 'Book Slot',
        },
    },
    types: {
        skill: 'Skills',
        road: 'Road',
        skillFull: 'Skills training',
        roadFull: 'Road training',
    },
    session: {
        detailsHeading: 'Session details',
        studentLabel: 'Student',
        typeLabel: 'Type',
        timeLabel: 'Time',
        truckLabel: 'Truck',
        statusLabel: 'Status',
        assignedByInstructor: 'Assigned by instructor',
        cancelConfirm: 'Cancel this training session?',
        cancelButton: 'Cancel session',
        cancellingButton: 'Cancelling...',
        cancelNotice: 'Cancelled sessions free up the slot for other students.',
        closeDetailsAria: 'Close session details',
    },
    statuses: {
        APPROVED: { label: 'Approved' },
        PENDING: { label: 'Pending', bookingNote: 'PENDING - Waiting for admin approval.' },
        REJECTED: { label: 'Rejected' },
        CANCELLED: { label: 'Cancelled' },
    },
    errors: {
        loadTrucks: 'Failed to load trucks',
        loadSessions: 'Failed to load training sessions',
        selectTruck: 'Select a truck for your training session.',
        overlapApproved: 'Cannot book this time because another approved session overlaps.',
        overlap: 'Cannot book this time because another session overlaps.',
        ownOverlap: 'You already have another session booked at this time.',
        skillLimit: 'You can only book up to 2 skill sessions per day.',
        roadLimit: 'You can only book one road session per day.',
        noSlot: 'Select a training time before booking.',
        sunday: 'Training sessions are not available on Sundays.',
        bookingFailed: 'Failed to book training session',
        cancelFailed: 'Failed to cancel session',
        pastSlot: 'Cannot book a past time slot.',
        slotApproved: 'That time slot is already approved and cannot be booked.',
        slotBooked: 'That time slot is already booked.',
    },
};

export const SCHEDULE_TRAINING_COPY = {
    uk: {
        header: {
            title: 'Запланувати тренування',
        },
        tabs: {
            skill: 'Навички',
            road: 'Дорога',
        },
        weekNav: {
            previous: '← Попередній тиждень',
            next: 'Наступний тиждень →',
        },
        messages: {
            noTrucks: 'Немає доступних тренувальних вантажівок. Зверніться до інструктора.',
            noTrucksForType: 'Немає доступних вантажівок для розділу {type}. Оберіть інший тип тренування або спробуйте пізніше.',
            booked: 'Заняття заброньовано на {time}. Статус: {status}',
            cancelSuccess: 'Заняття успішно скасовано.',
        },
        booking: {
            heading: {
                skill: 'Бронювання тренування з навичок',
                road: 'Бронювання дорожнього тренування',
            },
            selectedTime: 'Обраний час: {time}',
            confirm: 'Підтвердити бронювання',
            booking: 'Бронювання...',
            truckSelectLabel: 'Виберіть вантажівку',
            truckSelectPlaceholder: 'Оберіть вантажівку',
        },
        table: {
            time: 'Час',
            closed: 'Вихідний',
            yourSession: 'Ваше заняття',
            reserved: 'Зарезервований слот',
            buttons: {
                selected: 'Обрано',
                approved: 'Підтверджено',
                available: 'Забронювати слот',
            },
        },
        types: {
            skill: 'Навички',
            road: 'Дорога',
            skillFull: 'Тренування з навичок',
            roadFull: 'Дорожнє тренування',
        },
        session: {
            detailsHeading: 'Деталі заняття',
            studentLabel: 'Студент',
            typeLabel: 'Тип',
            timeLabel: 'Час',
            truckLabel: 'Вантажівка',
            statusLabel: 'Статус',
            assignedByInstructor: 'Призначено інструктором',
            cancelConfirm: 'Скасувати це тренування?',
            cancelButton: 'Скасувати заняття',
            cancellingButton: 'Скасування...',
            cancelNotice: 'Скасовані заняття звільняють слот для інших студентів.',
            closeDetailsAria: 'Закрити деталі заняття',
        },
        statuses: {
            APPROVED: { label: 'Підтверджено' },
            PENDING: { label: 'Очікує', bookingNote: 'ОЧІКУЄ - Потрібне підтвердження адміністратора.' },
            REJECTED: { label: 'Відхилено' },
            CANCELLED: { label: 'Скасовано' },
        },
        errors: {
            loadTrucks: 'Не вдалося завантажити список вантажівок.',
            loadSessions: 'Не вдалося завантажити заняття.',
            selectTruck: 'Оберіть вантажівку для тренування.',
            overlapApproved: 'Неможливо забронювати: інше підтверджене заняття перекриває цей час.',
            overlap: 'Неможливо забронювати: інше заняття перекриває цей час.',
            ownOverlap: 'У вас уже є заняття в цей час.',
            skillLimit: 'За день можна забронювати не більше 2 занять із навичок.',
            roadLimit: 'За день можна забронювати лише одне дорожнє заняття.',
            noSlot: 'Оберіть час тренування перед бронюванням.',
            sunday: 'У неділю тренування недоступні.',
            bookingFailed: 'Не вдалося забронювати тренування.',
            cancelFailed: 'Не вдалося скасувати заняття.',
            pastSlot: 'Неможливо забронювати минулий час.',
            slotApproved: 'Неможливо забронювати: цей час уже підтверджено.',
            slotBooked: 'Неможливо забронювати: цей час уже зайнятий.',
        },
    },
    ru: {
        header: {
            title: 'Запланировать тренировку',
        },
        tabs: {
            skill: 'Навыки',
            road: 'Дорога',
        },
        weekNav: {
            previous: '← Предыдущая неделя',
            next: 'Следующая неделя →',
        },
        messages: {
            noTrucks: 'Нет доступных учебных грузовиков. Свяжитесь с инструктором.',
            noTrucksForType: 'Нет доступных грузовиков для типа {type}. Выберите другой тип тренировки или попробуйте позже.',
            booked: 'Занятие забронировано на {time}. Статус: {status}',
            cancelSuccess: 'Занятие успешно отменено.',
        },
        booking: {
            heading: {
                skill: 'Бронирование тренировки по навыкам',
                road: 'Бронирование дорожной тренировки',
            },
            selectedTime: 'Выбранное время: {time}',
            confirm: 'Подтвердить бронь',
            booking: 'Бронирование...',
            truckSelectLabel: 'Выберите грузовик',
            truckSelectPlaceholder: 'Выберите грузовик',
        },
        table: {
            time: 'Время',
            closed: 'Закрыто',
            yourSession: 'Ваше занятие',
            reserved: 'Зарезервированный слот',
            buttons: {
                selected: 'Выбрано',
                approved: 'Одобрено',
                available: 'Забронировать слот',
            },
        },
        types: {
            skill: 'Навыки',
            road: 'Дорога',
            skillFull: 'Тренировка по навыкам',
            roadFull: 'Дорожная тренировка',
        },
        session: {
            detailsHeading: 'Детали занятия',
            studentLabel: 'Студент',
            typeLabel: 'Тип',
            timeLabel: 'Время',
            truckLabel: 'Грузовик',
            statusLabel: 'Статус',
            assignedByInstructor: 'Назначено инструктором',
            cancelConfirm: 'Отменить это занятие?',
            cancelButton: 'Отменить занятие',
            cancellingButton: 'Отмена...',
            cancelNotice: 'Отмененные занятия освобождают слот для других студентов.',
            closeDetailsAria: 'Закрыть детали занятия',
        },
        statuses: {
            APPROVED: { label: 'Одобрено' },
            PENDING: { label: 'В ожидании', bookingNote: 'В ОЖИДАНИИ - Требует подтверждения администратора.' },
            REJECTED: { label: 'Отклонено' },
            CANCELLED: { label: 'Отменено' },
        },
        errors: {
            loadTrucks: 'Не удалось загрузить список грузовиков.',
            loadSessions: 'Не удалось загрузить занятия.',
            selectTruck: 'Выберите грузовик для тренировки.',
            overlapApproved: 'Невозможно забронировать: другое одобренное занятие перекрывает это время.',
            overlap: 'Невозможно забронировать: другое занятие перекрывает это время.',
            ownOverlap: 'У вас уже есть занятие в это время.',
            skillLimit: 'За день можно забронировать не более 2 занятий по навыкам.',
            roadLimit: 'За день можно забронировать только одну дорожную тренировку.',
            noSlot: 'Выберите время тренировки перед бронированием.',
            sunday: 'В воскресенье тренировки недоступны.',
            bookingFailed: 'Не удалось забронировать тренировку.',
            cancelFailed: 'Не удалось отменить занятие.',
            pastSlot: 'Невозможно забронировать прошедшее время.',
            slotApproved: 'Невозможно забронировать: это время уже одобрено.',
            slotBooked: 'Невозможно забронировать: это время уже занято.',
        },
    },
    es: {
        header: {
            title: 'Programar entrenamiento',
        },
        tabs: {
            skill: 'Habilidades',
            road: 'Carretera',
        },
        weekNav: {
            previous: '← Semana anterior',
            next: 'Semana siguiente →',
        },
        messages: {
            noTrucks: 'No hay camiones de entrenamiento disponibles. Ponte en contacto con un instructor.',
            noTrucksForType: 'No hay camiones disponibles para {type}. Elige otro tipo de entrenamiento o vuelve más tarde.',
            booked: 'Sesión reservada para {time}. Estado: {status}',
            cancelSuccess: 'Sesión cancelada correctamente.',
        },
        booking: {
            heading: {
                skill: 'Reserva de entrenamiento de habilidades',
                road: 'Reserva de entrenamiento en carretera',
            },
            selectedTime: 'Hora seleccionada: {time}',
            confirm: 'Confirmar reserva',
            booking: 'Reservando...',
            truckSelectLabel: 'Selecciona un camión',
            truckSelectPlaceholder: 'Elige un camión',
        },
        table: {
            time: 'Hora',
            closed: 'Cerrado',
            yourSession: 'Tu sesión',
            reserved: 'Turno reservado',
            buttons: {
                selected: 'Seleccionado',
                approved: 'Aprobado',
                available: 'Reservar turno',
            },
        },
        types: {
            skill: 'Habilidades',
            road: 'Carretera',
            skillFull: 'Entrenamiento de habilidades',
            roadFull: 'Entrenamiento en carretera',
        },
        session: {
            detailsHeading: 'Detalles de la sesión',
            studentLabel: 'Estudiante',
            typeLabel: 'Tipo',
            timeLabel: 'Hora',
            truckLabel: 'Camión',
            statusLabel: 'Estado',
            assignedByInstructor: 'Asignado por el instructor',
            cancelConfirm: '¿Cancelar esta sesión de entrenamiento?',
            cancelButton: 'Cancelar sesión',
            cancellingButton: 'Cancelando...',
            cancelNotice: 'Las sesiones canceladas liberan el turno para otros estudiantes.',
            closeDetailsAria: 'Cerrar detalles de la sesión',
        },
        statuses: {
            APPROVED: { label: 'Aprobado' },
            PENDING: { label: 'Pendiente', bookingNote: 'PENDIENTE - A la espera de aprobación del administrador.' },
            REJECTED: { label: 'Rechazado' },
            CANCELLED: { label: 'Cancelado' },
        },
        errors: {
            loadTrucks: 'No se pudieron cargar los camiones.',
            loadSessions: 'No se pudieron cargar las sesiones.',
            selectTruck: 'Elige un camión para tu entrenamiento.',
            overlapApproved: 'No es posible reservar: otra sesión aprobada se superpone en este horario.',
            overlap: 'No es posible reservar: otra sesión se superpone en este horario.',
            ownOverlap: 'Ya tienes otra sesión reservada en este horario.',
            skillLimit: 'Solo puedes reservar hasta 2 sesiones de habilidades por día.',
            roadLimit: 'Solo puedes reservar una sesión en carretera por día.',
            noSlot: 'Elige un horario antes de reservar.',
            sunday: 'Los entrenamientos no están disponibles los domingos.',
            bookingFailed: 'No se pudo reservar la sesión de entrenamiento.',
            cancelFailed: 'No se pudo cancelar la sesión.',
            pastSlot: 'No es posible reservar un horario pasado.',
            slotApproved: 'No es posible reservar: otro turno aprobado ocupa este horario.',
            slotBooked: 'No es posible reservar: el turno ya está ocupado.',
        },
    },
};
